import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'STATUS_DOC',
  title: 'Was ist der Status eines Dokuments?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Jedem Dokumententitel folgt ein Piktogramm, an dem Sie den Status des Dokuments erkennen können:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Fehlt: das Dokument wurde nie abgelegt'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Unterschrift ausstehend: Das Dokument muss vom Zeichnungsberechtigten des Kontos unterzeichnet werden'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Abgelehnt: das Dokument wurde abgelehnt, bitte überprüfen Sie den Grund für die Ablehnung'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Abgelaufen: das Dokument hat sein Verfallsdatum überschritten'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ausstehende Abholung: das Dokument wird von unseren Diensten abgeholt'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Erfassung ausstehend: alle hinterlegten Dokumente werden von ALG-Services verifiziert und authentifiziert'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Bald ungültig : Das Dokument wird bald ungültig'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_8.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Nicht zutreffend: Das Dokument trifft nicht auf Ihre Organisation zu'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_9.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Gültig: Das Dokument ist für Ihre Kunden verfügbar'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_STATUT_DOC/DE_STATUT_DOC_10.png`
  }]
};
